const GtfsApi = {
    formatServiceDateAsLongDate: (date) => {
        if (date && date.length == 8) {
            const d = new Date(date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) + 'T00:00:00');

            if (d) {
                return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            }
        }

        return null;
    },

    formatServiceDateAsMonth: (date) => {
        if (date && date.length == 8) {
            const d = new Date(date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) + 'T00:00:00');

            if (d) {
                return d.toLocaleDateString('en-US', { month: 'long' });
            }
        }

        return null;
    },

    formatServiceDateAsTimestamp: (date) => {
        if (date && date.length == 8) {
            const d = new Date(date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) + 'T00:00:00');

            if (d) {
                return Math.floor(d.getTime() / 1000);
            }
        }

        return null;
    },

    getFeedInfo: () => GtfsApi._fetch('feedinfo', { }),

    getShapes: (tripId) => GtfsApi._fetch('shapes', { tripId }),

    getShapesMultiple: (tripIds) => GtfsApi._post('shapes', { tripIds: tripIds.join(',') }),

    getStops: () => GtfsApi._fetch('stops', { }),

    _fetch: (resource, params) => {
        let qs = new URLSearchParams();

        if (params) {
            for (let param in params) {
                if (Object.prototype.hasOwnProperty.call(params, param)) {
                    qs.append(param, params[param]);
                }
            }
        }

        return fetch(gtfsApiUrl + '/' + resource + '?' + qs.toString());
    },

    _post: (resource, params) => {
        let fd = new FormData();

        if (params) {
            for (let param in params) {
                if (Object.prototype.hasOwnProperty.call(params, param)) {
                    fd.append(param, params[param]);
                }
            }
        }

        return fetch(gtfsApiUrl + '/' + resource, { method: 'POST', body: fd });
    }
};

export default GtfsApi;